import {apiUrl} from 'config';
export default {
    viewName: 'userInfo',
    viewItemsKey: 'info',
    api:apiUrl+'/doctor/info'
}


// WEBPACK FOOTER //
// ./pages/user/components/ajax-config.js